import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as acts from "../../redux/investigation/actions";
import { Badge, Button, Grid, IconButton, Snackbar } from "@mui/material";
import FilterModalNewForDBSearch from "./FilterModalNewForDBSearch";
import CloseIcon from "@mui/icons-material/Close";
import CustomizedSnackbars from "../Snackbars/CustomizedSnackbars";
import "./filter.scss";
import TuneIcon from "@mui/icons-material/Tune";
import DataInvestigationReportsDialog from "./DataInvestigationReportsDialog";
import { LoadingButton } from "@mui/lab";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FilterNewForDBSearch from "./FilterNewForDBSearch";

export default function InvestigationFilterNewForDBSearch(props) {
  const dispatch = useDispatch();

  const exportInvestigationDataStatus = useSelector(
    (state) => state?.investigation?.exportInvestigationDataStatus
  );
  const projectsParameters = useSelector(
    (state) => state?.investigation?.projectsParameters
  );
  const projectNameApiStatus = useSelector(
    (state) => state?.investigation?.projectNameApiStatus
  );

  const filterData = {
    parameterName: "",
    rangeType: "Exact",
    minValue: "",
    maxValue: "",
  };

  const [parameters, setParameters] = useState({});
  const [filtersData, setFiltersData] = useState([filterData]);

  const [openModal, setOpenModal] = useState(false);
  const [emptyProjectNameSnackBar, setEmptyProjectNameSnackBar] =
    useState(false);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [openReportsDialog, setOpenReportsDialog] = useState(false);
  const [enableExport, setEnableExport] = useState(false);

  useEffect(() => {
    dispatch(acts.getProjectsWithParameters());
    dispatch(acts.clearProjectNameApiStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (projectsParameters && projectsParameters.length > 0) {
      setParameters(projectsParameters);
    }
  }, [projectsParameters]);

  useEffect(() => {
    if (
      projectNameApiStatus?.apiError === true &&
      projectNameApiStatus?.next === false
    ) {
      setMessage(projectNameApiStatus?.message);
      setErr(true);
    }
  }, [projectNameApiStatus]);

  useEffect(() => {
    handleSearch("renderCall");
  }, []);

  const handleChangeFilter = (index, data) => {
    setEnableExport(false);
    const newData = data;
    if (newData?.rangeType === "Exact" && newData?.maxValue !== "") {
      newData.maxValue = "";
    }

    filtersData[index] = newData;
    setFiltersData([...filtersData]);
  };

  const handleAddFilter = () => {
    filtersData.push(filterData);

    setFiltersData([...filtersData]);
  };

  const handleRemoveFilter = (index) => {
    filtersData.splice(index, 1);

    setFiltersData([...filtersData]);
  };

  const handleClearAll = () => {
    const length = filtersData.length;
    const clearedArry = [];
    for (let i = 0; i < length; i++) {
      clearedArry.push({
        parameterName: "",
        rangeType: "Exact",
        minValue: "",
        maxValue: "",
      });
    }
    setFiltersData([...clearedArry]);
  };

  const clearFirstFilter = () => {
    filtersData[0] = filterData;
    setFiltersData([...filtersData]);
  };

  const handleSearch = (from) => {
    if (from !== "renderCall") {
      const allProjectsHaveName = filtersData.every(
        (data) => data.parameterName !== "" && data.parameterName !== null
      );
      if (allProjectsHaveName) {
        props.getFilteredData(filtersData, "searchClick");
      } else {
        setEmptyProjectNameSnackBar(true);
      }
    } else props.getFilteredData(filtersData);

    setEnableExport(true);
  };

  const handleDrawerClose = () => {
    const firstElementOnly = filtersData[0];
    setFiltersData([{ ...firstElementOnly }]);
    setOpenModal(false);
  };

  const handleCloseSnack = () => {
    setEmptyProjectNameSnackBar(false);
  };

  const handleOpenReportDialog = () => {
    setOpenReportsDialog(true);
  };

  const handleClose = () => {
    setOpenReportsDialog(false);
  };

  const clearAllFilter = () => {
    setFiltersData([filterData]);
    props.getFilteredData([filterData]);
  };
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnack}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div className="filter-main-div">
      <div style={{ display: "flex", flexDirection: "row" }}>
        <FilterNewForDBSearch
          index={0}
          filtersData={filtersData[0]}
          parameters={parameters}
          handleChangeFilter={handleChangeFilter}
          clearFirstFilter={clearFirstFilter}
        />
      </div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className="filter-buttons"
      >
        <Grid container item md={7}>
          <Grid item>
            <Button
              className="btn-search"
              variant="contained"
              onClick={() => setOpenModal(true)}
              disabled={
                filtersData[0]?.parameterName === "" ||
                filtersData[0]?.parameterName === null
              }
            >
              + Add Another Filter
            </Button>
          </Grid>

          <Grid item>
            <IconButton
              aria-label="delete"
              onClick={() => setOpenModal(true)}
              disabled={filtersData.length < 2}
              color="primary"
              variant="contained"
            >
              <Badge
                badgeContent={filtersData.length < 2 ? 0 : filtersData.length}
                color="error"
              >
                <TuneIcon />
              </Badge>
            </IconButton>
          </Grid>

          <Grid item>
            <Button className="btn-search" onClick={() => clearAllFilter()}>
              Clear All
            </Button>
          </Grid>

          <Grid item>
            <Button
              className="btn-search"
              variant="contained"
              onClick={() => handleSearch("fromDashboard")}
              disabled={
                filtersData[0]?.parameterName === "" ||
                filtersData[0]?.parameterName === null
              }
            >
              Search
            </Button>
          </Grid>
        </Grid>

        <Grid container item md={5} justifyContent="flex-end">
          <Grid item>
            <LoadingButton
              onClick={props.export}
              disabled={!enableExport || props?.noTableData}
              loading={exportInvestigationDataStatus?.loader}
              loadingPosition="start"
              startIcon={<FileDownloadOutlinedIcon />}
              variant="contained"
            >
              Generate Report
            </LoadingButton>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              className="btn-search"
              onClick={() => handleOpenReportDialog()}
            >
              Previous Reports
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {openModal && (
        <FilterModalNewForDBSearch
          open={openModal}
          handleClose={() => setOpenModal(false)}
          filtersData={filtersData}
          parameters={parameters}
          handleChangeFilter={handleChangeFilter}
          handleAddFilter={handleAddFilter}
          handleRemoveFilter={handleRemoveFilter}
          handleClearAll={handleClearAll}
          handleSearch={() => handleSearch("fromModal")}
          handleDrawerClose={handleDrawerClose}
          clearFirstFilter={clearFirstFilter}
        />
      )}

      {openReportsDialog && (
        <DataInvestigationReportsDialog
          openReportsDialog={openReportsDialog}
          handleClose={() => handleClose()}
        />
      )}

      <Snackbar
        open={emptyProjectNameSnackBar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={6000}
        onClose={handleCloseSnack}
        message="Please fill in the parameter names for all the search inputes."
        action={action}
      />

      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </div>
  );
}
